const helpers = {
    methods: {
        toastAlert(message, type) {
            this.$toast.open({
                message: message,
                type: type, //success, info, warning, error, default
            });
        },
    }
}

export default helpers